import { motion, AnimatePresence } from "framer-motion";

const variants = {
  success: "border-emerald-200 bg-emerald-50 text-emerald-700",
  error: "border-rose-200 bg-rose-50 text-rose-700",
  info: "border-blue-200 bg-blue-50 text-blue-700",
};

const Toast = ({ message, type = "success", visible, onDismiss }) => (
  <AnimatePresence>
    {visible && (
      <motion.div
        initial={{ opacity: 0, y: -60, x: "-50%" }}
        animate={{ opacity: 1, y: 0, x: "-50%" }}
        exit={{ opacity: 0, y: -60, x: "-50%", scale: 0.95 }}
        transition={{ type: "spring", stiffness: 300, damping: 25 }}
        onClick={onDismiss}
        className={`fixed top-4 left-1/2 z-[100] cursor-pointer rounded-2xl border px-5 py-3 text-sm font-semibold shadow-lg ${variants[type]}`}
      >
        {message}
      </motion.div>
    )}
  </AnimatePresence>
);

export default Toast;
